// extracted by mini-css-extract-plugin
export const root = "image-gallery-section-module--root--3o7WM";
export const imageGrid = "image-gallery-section-module--imageGrid--2pvOp";